import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { observer } from 'mobx-react';

interface Props {
	taxonomyRequest: DropdownRequest<TaxonomySummary>;
	value: string | null;
	mode: ControlMode;
	onChange: (value: TaxonomySummary | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class TaxonomyEditorView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const { label, value, required, mode, taxonomyRequest, onChange } = this.props;

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={value}
				required={required}
				disabled={mode === 'display'}
				onChanged={onChange}
				request={taxonomyRequest}
				keyField="jsonSchemaDefinitionName"
				textField="displayName"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/parts/taxonomy-editor.view.tsx